/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Delayer = /** @class */ (function () {
    function Delayer(defaultDelay) {
        this.defaultDelay = defaultDelay;
        this.timeout = undefined;
        this.completionPromise = undefined;
        this.onSuccess = undefined;
        this.task = undefined;
    }
    Delayer.prototype.trigger = function (task, delay) {
        var _this = this;
        if (delay === void 0) { delay = this.defaultDelay; }
        this.task = task;
        if (delay >= 0) {
            this.cancelTimeout();
        }
        if (!this.completionPromise) {
            this.completionPromise = new Promise(function (resolve) {
                _this.onSuccess = resolve;
            }).then(function () {
                _this.completionPromise = undefined;
                _this.onSuccess = undefined;
                var result = _this.task();
                _this.task = undefined;
                return result;
            });
        }
        if (delay >= 0 || this.timeout === void 0) {
            this.timeout = setTimeout(function () {
                _this.timeout = undefined;
                _this.onSuccess(undefined);
            }, delay >= 0 ? delay : this.defaultDelay);
        }
        return this.completionPromise;
    };
    Delayer.prototype.forceDelivery = function () {
        if (!this.completionPromise) {
            return undefined;
        }
        this.cancelTimeout();
        var result = this.task();
        this.completionPromise = undefined;
        this.onSuccess = undefined;
        this.task = undefined;
        return result;
    };
    Delayer.prototype.isTriggered = function () {
        return this.timeout !== void 0;
    };
    Delayer.prototype.cancel = function () {
        this.cancelTimeout();
        this.completionPromise = undefined;
    };
    Delayer.prototype.cancelTimeout = function () {
        if (this.timeout !== void 0) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    };
    return Delayer;
}());
exports.Delayer = Delayer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vscode-base-languageclient/lib/utils/async.js
// module id = 633
// module chunks = 0